import { render, staticRenderFns } from "./PermissionMatrix.vue?vue&type=template&id=7aab245e&scoped=true"
import script from "./PermissionMatrix.vue?vue&type=script&lang=js"
export * from "./PermissionMatrix.vue?vue&type=script&lang=js"
import style0 from "./PermissionMatrix.vue?vue&type=style&index=0&id=7aab245e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aab245e",
  null
  
)

export default component.exports